// Spotify API 音乐服务
console.log('🎵 音乐服务初始化 - Spotify 集成版本')

// API配置
const SPOTIFY_CONFIG = {
  clientId: import.meta.env.VITE_SPOTIFY_CLIENT_ID || '9539695bc140401084f0334c1c1fad61',
  clientSecret: import.meta.env.VITE_SPOTIFY_CLIENT_SECRET || '17d83478a6c24ba0b9b60056bf52c8ae',
  redirectUri: import.meta.env.VITE_SPOTIFY_REDIRECT_URI || 'https://070766.xyz/callback',
  redirectUriDev: import.meta.env.VITE_SPOTIFY_REDIRECT_URI_DEV || 'http://localhost:3000/callback',
  apiUrl: 'https://api.spotify.com/v1',
  authUrl: 'https://accounts.spotify.com/api/token'
}

// 检查是否为开发环境
const isDev = import.meta.env.DEV

// 智能检测当前主机地址（用于本地开发）
const getCurrentHostUrl = () => {
  if (typeof window !== 'undefined') {
    return `${window.location.protocol}//${window.location.host}`
  }
  return 'http://localhost:3000'
}

const REDIRECT_URI = isDev 
  ? import.meta.env.VITE_SPOTIFY_REDIRECT_URI_DEV || `${getCurrentHostUrl()}/callback`
  : SPOTIFY_CONFIG.redirectUri

// 令牌管理
let spotifyToken = null
let tokenExpiry = 0

console.log('🔧 Spotify 配置:', {
  clientId: SPOTIFY_CONFIG.clientId.substring(0, 8) + '...',
  redirectUri: REDIRECT_URI,
  isDev
})

// 获取 Spotify 访问令牌（客户端凭据流 - 用于搜索公开内容）
async function getSpotifyToken() {
  if (spotifyToken && Date.now() < tokenExpiry) {
    console.log('✅ 使用缓存的 Spotify 令牌')
    return spotifyToken
  }

  try {
    console.log('🔑 获取新的 Spotify 访问令牌...')
    
    const response = await fetch(SPOTIFY_CONFIG.authUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Basic ' + btoa(`${SPOTIFY_CONFIG.clientId}:${SPOTIFY_CONFIG.clientSecret}`)
      },
      body: 'grant_type=client_credentials'
    })

    if (!response.ok) {
      throw new Error(`Token 请求失败: ${response.status}`)
    }

    const data = await response.json()
    spotifyToken = data.access_token
    tokenExpiry = Date.now() + (data.expires_in * 1000) - 60000 // 提前1分钟过期
    
    console.log('✅ Spotify 令牌获取成功，有效期:', Math.round(data.expires_in / 60), '分钟')
    return spotifyToken
  } catch (error) {
    console.error('❌ Spotify 令牌获取失败:', error)
    throw error
  }
}

// 根据心情获取搜索关键词 - 使用具体热门歌曲和艺术家
function getMoodSearchTerms(mood, weather, location) {
  const moodKeywords = {
    '开心': [
      'Happy Pharrell Williams', 'Can\'t Stop The Feeling Justin Timberlake', 'Uptown Funk Bruno Mars', 
      'Good as Hell Lizzo', 'Shake It Off Taylor Swift', 'Walking on Sunshine Katrina Waves',
      'Sunflower Post Malone', 'Better Days OneRepublic', 'High Hopes Panic At The Disco'
    ],
    '放松': [
      'Perfect Ed Sheeran', 'Thinking Out Loud Ed Sheeran', 'Stay With Me Sam Smith', 
      'Someone You Loved Lewis Capaldi', 'All of Me John Legend', 'A Thousand Years Christina Perri',
      'Skinny Love Bon Iver', 'Holocene Bon Iver', 'Vienna Billy Joel'
    ],
    '伤心': [
      'Someone Like You Adele', 'Hello Adele', 'All Too Well Taylor Swift',
      'Hurt Johnny Cash', 'Mad World Gary Jules', 'The Night We Met Lord Huron',
      'Breathe Me Sia', 'Skinny Love Bon Iver', 'Black Radiohead'
    ],
    '兴奋': [
      'Levitating Dua Lipa', 'Blinding Lights The Weeknd', 'Don\'t Start Now Dua Lipa',
      'good 4 u Olivia Rodrigo', 'As It Was Harry Styles', 'About Damn Time Lizzo',
      'Anti-Hero Taylor Swift', 'Heat Waves Glass Animals', 'Stay The Kid LAROI'
    ],
    '孤独': [
      'Lonely Justin Bieber', 'Somebody That I Used To Know Gotye', 'Mad World Gary Jules',
      'The Sound of Silence Disturbed', 'Hurt Nine Inch Nails', 'Creep Radiohead',
      'Black Pearl Jam', 'Nutshell Alice in Chains', 'Tears in Heaven Eric Clapton'
    ],
    '愤怒': [
      'Stronger Kelly Clarkson', 'Fighter Christina Aguilera', 'Roar Katy Perry',
      'Since U Been Gone Kelly Clarkson', 'You Oughta Know Alanis Morissette', 'Break Stuff Limp Bizkit',
      'Bodies Drowning Pool', 'Chop Suey System of a Down', 'B.Y.O.B. System of a Down'
    ],
    '浪漫': [
      'Perfect Ed Sheeran', 'All of Me John Legend', 'Thinking Out Loud Ed Sheeran',
      'Make You Feel My Love Adele', 'At Last Etta James', 'The Way You Look Tonight Tony Bennett',
      'L-O-V-E Nat King Cole', 'Fly Me to the Moon Frank Sinatra', 'Wonderful Tonight Eric Clapton'
    ],
    '怀旧': [
      'Bohemian Rhapsody Queen', 'Hotel California Eagles', 'Sweet Child O Mine Guns N Roses',
      'Don\'t Stop Believin Journey', 'Livin on a Prayer Bon Jovi', 'Africa Toto',
      'Take On Me a-ha', 'Billie Jean Michael Jackson', 'Purple Rain Prince'
    ],
    '专注': [
      'Ludovico Einaudi Nuvole Bianche', 'Max Richter On The Nature of Daylight', 'Ólafur Arnalds Near Light',
      'Clint Mansell Lux Aeterna', 'Hans Zimmer Time', 'Thomas Newman Any Other Name',
      'Dustin O\'Halloran Opus 36', 'Nils Frahm Says', 'GoGo Penguin Hopopono'
    ],
    '睡眠': [
      'Claire de Lune Claude Debussy', 'Weightless Marconi Union', 'Gymnopédie No.1 Erik Satie',
      'Sleep Baby Sleep INXS', 'Sleepyhead Passion Pit', 'Dream a Little Dream Ella Fitzgerald',
      'Moon River Audrey Hepburn', 'La Vie En Rose Édith Piaf', 'The Night We Met Lord Huron'
    ]
  }

  // 根据天气调整关键词
  const weatherKeywords = {
    'sunny': ['bright', 'summer', 'tropical'],
    'rainy': ['rain', 'melancholy', 'cozy'],
    'cloudy': ['mellow', 'atmospheric'],
    'snow': ['winter', 'cozy', 'warm'],
    'clear': ['uplifting', 'fresh']
  }

  let keywords = moodKeywords[mood] || ['music', 'song', 'melody']
  
  // 添加天气相关关键词
  if (weather?.weather?.[0]?.main) {
    const weatherCondition = weather.weather[0].main.toLowerCase()
    const additionalKeywords = weatherKeywords[weatherCondition] || []
    keywords = [...keywords, ...additionalKeywords]
  }

  console.log(`🔍 为心情 "${mood}" 生成的搜索关键词:`, keywords)
  return keywords
}

// 搜索 Spotify 音乐
async function searchSpotifyTracks(query, limit = 20) {
  try {
    console.log(`🔍 正在搜索 Spotify 音乐: "${query}"`)
    const token = await getSpotifyToken()
    
    const params = new URLSearchParams({
      q: query,
      type: 'track',
      limit: Math.min(limit, 50).toString(), // 增加搜索限制到50首
      market: 'from_token' // 使用用户的市场，通常有更多预览音频
    })

    const response = await fetch(`${SPOTIFY_CONFIG.apiUrl}/search?${params}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })

    if (!response.ok) {
      throw new Error(`Spotify 搜索失败: ${response.status}`)
    }

    const data = await response.json()
    console.log(`✅ 找到 ${data.tracks.items.length} 首曲目`)
    
    const tracks = data.tracks.items.map(track => ({
      id: track.id,
      title: track.name,
      artist: track.artists.map(artist => artist.name).join(', '),
      album: track.album.name,
      duration: Math.floor(track.duration_ms / 1000),
      audioUrl: track.preview_url, // Spotify 30秒预览
      artwork: track.album.images[0]?.url || track.album.images[1]?.url,
      spotifyUrl: track.external_urls.spotify,
      source: 'Spotify',
      license: 'Spotify Preview',
      popularity: track.popularity,
      explicit: track.explicit,
      hasPreview: !!track.preview_url
    }))
    
    const tracksWithPreview = tracks.filter(track => track.audioUrl)
    const tracksWithoutPreview = tracks.filter(track => !track.audioUrl)
    
    console.log(`🎵 曲目统计: 总计 ${tracks.length}, 有预览 ${tracksWithPreview.length}, 无预览 ${tracksWithoutPreview.length}`)
    
    // 如果有预览音频的曲目，优先返回
    if (tracksWithPreview.length > 0) {
      return tracksWithPreview
    }
    
    // 如果没有预览音频的曲目，返回所有曲目但标记为无预览
    console.log('⚠️ 没有找到有预览音频的曲目，返回无预览曲目供展示')
    return tracksWithoutPreview.map(track => ({
      ...track,
      audioUrl: null, // 明确标记为无预览
      source: 'Spotify (无预览)',
      canPlay: false
    }))
  } catch (error) {
    console.error('❌ Spotify 搜索错误:', error)
    throw error
  }
}

// 生成模拟数据（当 API 不可用时使用）
function generateMockTracks(mood, count = 10) {
  console.log('🎭 使用模拟数据，心情:', mood)
  
  // 使用支持CORS的Google音频源
  const testAudioUrls = [
    'https://actions.google.com/sounds/v1/alarms/bugle_tune.ogg',
    'https://actions.google.com/sounds/v1/cartoon/clang_and_wobble.ogg',
    'https://actions.google.com/sounds/v1/cartoon/cartoon_boing.ogg',
    'https://actions.google.com/sounds/v1/cartoon/wood_plank_flicks.ogg',
    'https://actions.google.com/sounds/v1/cartoon/siren_whistle.ogg',
    'https://actions.google.com/sounds/v1/cartoon/cowbell_ringing.ogg',
    'https://www.learningcontainer.com/wp-content/uploads/2020/02/Kalimba.mp3',
  ]

  // 创建与音频内容匹配的曲目信息
  const mockTracks = [
    {
      id: 'mock_1',
      title: 'Bugle Morning Call',
      artist: 'Sound Effects Studio',
      album: 'Audio Samples Collection',
      duration: 15,
      audioUrl: testAudioUrls[0],
      artwork: 'https://picsum.photos/300/300?random=1',
      source: '演示音频',
      license: 'Google Actions Audio'
    },
    {
      id: 'mock_2',
      title: 'Clang & Wobble',
      artist: 'Cartoon Audio FX',
      album: 'Comic Sound Effects',
      duration: 8,
      audioUrl: testAudioUrls[1],
      artwork: 'https://picsum.photos/300/300?random=2',
      source: '演示音频',
      license: 'Google Actions Audio'
    },
    {
      id: 'mock_3',
      title: 'Cartoon Boing',
      artist: 'Animation Sounds',
      album: 'Funny Audio Collection',
      duration: 5,
      audioUrl: testAudioUrls[2],
      artwork: 'https://picsum.photos/300/300?random=3',
      source: '演示音频',
      license: 'Google Actions Audio'
    },
    {
      id: 'mock_4',
      title: 'Wood Plank Flicks',
      artist: 'Percussion Studio',
      album: 'Natural Sounds',
      duration: 10,
      audioUrl: testAudioUrls[3],
      artwork: 'https://picsum.photos/300/300?random=4',
      source: '演示音频',
      license: 'Google Actions Audio'
    },
    {
      id: 'mock_5',
      title: 'Siren Whistle',
      artist: 'Alert Sounds Co.',
      album: 'Emergency Audio Pack',
      duration: 12,
      audioUrl: testAudioUrls[4],
      artwork: 'https://picsum.photos/300/300?random=5',
      source: '演示音频',
      license: 'Google Actions Audio'
    },
    {
      id: 'mock_6',
      title: 'Cowbell Ringing',
      artist: 'Farm Sounds',
      album: 'Rural Audio Collection',
      duration: 8,
      audioUrl: testAudioUrls[5],
      artwork: 'https://picsum.photos/300/300?random=6',
      source: '演示音频',
      license: 'Google Actions Audio'
    },
    {
      id: 'mock_7',
      title: 'Kalimba Dreams',
      artist: 'Instrumental Vibes',
      album: 'World Music Samples',
      duration: 180,
      audioUrl: testAudioUrls[6],
      artwork: 'https://picsum.photos/300/300?random=7',
      source: '演示音乐',
      license: 'Learning Container Sample'
    }
  ]

  // 根据心情调整标题
  const moodAdjustments = {
    '开心': ['Joyful', 'Bright', 'Cheerful', 'Uplifting', 'Vibrant'],
    '放松': ['Peaceful', 'Calm', 'Serene', 'Tranquil', 'Gentle'],
    '伤心': ['Melancholy', 'Emotional', 'Tender', 'Wistful', 'Somber'],
    '兴奋': ['Electric', 'Energetic', 'Dynamic', 'Thrilling', 'Intense']
  }

  const adjustments = moodAdjustments[mood] || ['Musical', 'Harmonic', 'Melodic', 'Rhythmic', 'Sonic']
  
  return mockTracks.slice(0, Math.min(count, mockTracks.length)).map((track, index) => ({
    ...track,
    id: `${mood}_${track.id}_${index}`,
    title: track.source === '演示音乐' ? `${adjustments[index % adjustments.length]} ${track.title}` : track.title,
    artwork: `https://picsum.photos/300/300?random=${Date.now()}_${index}`,
  }))
}

// 主要的音乐推荐函数
export async function getMusicRecommendations(params) {
  const { mood, weather, location, count = 20 } = params
  
  console.log('🎵 获取音乐推荐，参数:', { mood, weather: weather?.weather?.[0]?.main, location: location?.name, count })
  console.log('🔧 Spotify 配置检查:', {
    hasClientId: !!SPOTIFY_CONFIG.clientId,
    hasClientSecret: !!SPOTIFY_CONFIG.clientSecret,
    clientIdSample: SPOTIFY_CONFIG.clientId?.substring(0, 8) + '...',
    redirectUri: REDIRECT_URI
  })

  try {
    // 检查 Spotify 配置
    if (SPOTIFY_CONFIG.clientId.includes('your-spotify-client-id') || !SPOTIFY_CONFIG.clientId) {
      console.log('⚠️ Spotify API 未配置，使用模拟数据')
      return generateMockTracks(mood, count)
    }

    // 先测试令牌获取
    console.log('🔑 尝试获取 Spotify 访问令牌...')
    try {
      const token = await getSpotifyToken()
      console.log('✅ 令牌获取成功:', token ? '✓' : '✗')
    } catch (tokenError) {
      console.error('❌ 令牌获取失败，详细错误:', tokenError)
      throw new Error(`令牌获取失败: ${tokenError.message}`)
    }

    // 生成搜索关键词
    const keywords = getMoodSearchTerms(mood, weather, location)
    console.log('🔍 搜索关键词:', keywords.slice(0, 3))
    
    // 尝试多个搜索词获取更多结果 - 增加搜索词数量提高命中率
    let allTracks = []
    let tracksWithPreview = []
    let tracksWithoutPreview = []
    const searchLimit = Math.min(keywords.length, 6) // 增加到6个关键词
    const tracksPerKeyword = Math.ceil((count * 2) / searchLimit) // 每个关键词搜索更多音乐
    
    for (let i = 0; i < searchLimit; i++) {
      try {
        console.log(`🔍 正在搜索关键词 ${i + 1}/${searchLimit}: "${keywords[i]}"`)
        const tracks = await searchSpotifyTracks(keywords[i], tracksPerKeyword)
        console.log(`✅ 关键词 "${keywords[i]}" 返回 ${tracks.length} 首曲目`)
        
        // 分类处理有无预览的曲目
        const withPreview = tracks.filter(track => track.audioUrl && track.hasPreview !== false)
        const withoutPreview = tracks.filter(track => !track.audioUrl || track.hasPreview === false)
        
        console.log(`  📊 "${keywords[i]}": 有预览 ${withPreview.length}, 无预览 ${withoutPreview.length}`)
        
        tracksWithPreview = [...tracksWithPreview, ...withPreview]
        tracksWithoutPreview = [...tracksWithoutPreview, ...withoutPreview]
        allTracks = [...allTracks, ...tracks]
        
        // 如果已经找到足够多的有预览音频，可以提前结束
        if (tracksWithPreview.length >= count) {
          console.log(`✅ 已找到足够多的有预览音频 (${tracksWithPreview.length} 首)，停止搜索`)
          break
        }
      } catch (error) {
        console.error(`❌ 搜索关键词 "${keywords[i]}" 失败:`, error.message, error)
        continue
      }
    }

    console.log(`📊 搜索结果统计: 总计 ${allTracks.length} 首曲目`)
    console.log(`📊 预览音频统计: 有预览 ${tracksWithPreview.length} 首, 无预览 ${tracksWithoutPreview.length} 首`)

    // 去重函数
    const removeDuplicates = (tracks) => tracks.filter((track, index, self) => 
      index === self.findIndex(t => t.id === track.id)
    )

    // 优先使用有预览音频的曲目
    const uniqueWithPreview = removeDuplicates(tracksWithPreview).slice(0, count)
    
    if (uniqueWithPreview.length > 0) {
      console.log(`✅ 成功获取 ${uniqueWithPreview.length} 首有预览的 Spotify 音乐`)
      console.log('🎵 示例曲目:', uniqueWithPreview.slice(0, 3).map(t => `${t.title} - ${t.artist}`))
      return uniqueWithPreview
    }
    
    // 如果没有有预览的曲目，返回无预览曲目但标记清楚
    const uniqueWithoutPreview = removeDuplicates(tracksWithoutPreview).slice(0, count)
    
    if (uniqueWithoutPreview.length > 0) {
      console.log(`✅ 成功获取 ${uniqueWithoutPreview.length} 首 Spotify 音乐 (无预览音频)`)
      console.log('🎵 示例曲目:', uniqueWithoutPreview.slice(0, 3).map(t => `${t.title} - ${t.artist} (无预览)`))
      return uniqueWithoutPreview
    } else {
      throw new Error('没有找到任何 Spotify 曲目')
    }

  } catch (error) {
    console.error('❌ Spotify API 调用完全失败，详细错误:', error)
    console.warn('⚠️ 回退到模拟数据')
    return generateMockTracks(mood, count)
  }
}

// 搜索音乐
export async function searchMusic(query, limit = 20) {
  console.log(`🔍 搜索音乐: "${query}"`)
  
  try {
    if (SPOTIFY_CONFIG.clientId.includes('your-spotify-client-id') || !SPOTIFY_CONFIG.clientId) {
      console.log('⚠️ Spotify API 未配置，使用模拟搜索结果')
      return generateMockTracks('搜索', limit)
    }

    const tracks = await searchSpotifyTracks(query, limit)
    console.log(`✅ 搜索完成，找到 ${tracks.length} 首曲目`)
    return tracks
    
  } catch (error) {
    console.warn('⚠️ 搜索失败，使用模拟数据:', error.message)
    return generateMockTracks('搜索', limit)
  }
}

// 获取用户认证 URL（用于完整版 Spotify 集成）
export function getSpotifyAuthUrl() {
  const scopes = [
    'streaming',
    'user-read-email',
    'user-read-private',
    'user-library-read',
    'user-library-modify',
    'user-read-playback-state',
    'user-modify-playback-state'
  ]

  const params = new URLSearchParams({
    client_id: SPOTIFY_CONFIG.clientId,
    response_type: 'code',
    redirect_uri: REDIRECT_URI,
    scope: scopes.join(' '),
    state: generateRandomString(16)
  })

  return `https://accounts.spotify.com/authorize?${params}`
}

// 生成随机字符串（用于OAuth状态参数）
function generateRandomString(length) {
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  return Array.from(crypto.getRandomValues(new Uint8Array(length)))
    .map(x => possible[x % possible.length])
    .join('')
}

// 导出配置供其他组件使用
export { SPOTIFY_CONFIG, REDIRECT_URI }

console.log('✅ Spotify 音乐服务初始化完成')